import { RefOption } from "../agenda/types";
import { IRefOptionsService } from "./IRefOptionsService";

export class RefOptionsServiceMock implements IRefOptionsService {
  private mockCodes: string[] = [
    "COUNTRY",
    "DISCOUNT_TYPE",
    "FILE_TYPE",
    "FUR",
    "GENDER",
    "PRODUCT_TYPE",
    "SERVICE_SUB_TYPE",
    "SERVICE_TYPE",
    "SIZE",
    "SLOT_TYPE",
    "SPECIES",
    "SUB_SPECIES",
  ];

  private mockRefOptions: RefOption[] = [
    {
      id: 286,
      parent: "",
      code: "COUNTRY",
      value: "Nepal",
      description: "País: Nepal",
      isActive: true,
    },
    {
      id: 287,
      parent: "",
      code: "COUNTRY",
      value: "Brazil",
      description: "País: Brazil",
      isActive: true,
    },
    {
      id: 288,
      parent: "",
      code: "GENDER",
      value: "Male",
      description: "Género: Macho",
      isActive: true,
    },
    {
      id: 289,
      parent: "",
      code: "GENDER",
      value: "Female",
      description: "Género: Hembra",
      isActive: true,
    },
    {
      id: 290,
      parent: "",
      code: "SPECIES",
      value: "Dog",
      description: "Especie: Perro",
      isActive: true,
    },
    {
      id: 291,
      parent: "",
      code: "SPECIES",
      value: "Cat",
      description: "Especie: Gato",
      isActive: true,
    },
  ];

  async getOptionCodes(): Promise<string[]> {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [...this.mockCodes];
  }

  async getOptionsByCode(code: string): Promise<RefOption[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return this.mockRefOptions.filter(option => option.code === code);
  }
}
